import { goto } from '$app/navigation';

export const checkoutHandler = (setDrawerCallback, checkoutUrl) => {
    document.cookie = `checkoutUrl=${checkoutUrl}; path=/checkout; SameSite=Lax; Secure`;
    setDrawerCallback(false);
    goto('/checkout');
};
